import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { SiteHeader } from '../../components/SiteHeader';
import { SiteFooter } from '../../components/SiteFooter';
import { Reveal } from '../../components/landing/Reveal';

const LINKS: Array<{ to: string; key: string }> = [
  { to: '/pricing', key: 'pricing' },
  { to: '/compare', key: 'compare' },
  { to: '/security', key: 'security' },
  { to: '/demo', key: 'demo' },
];

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SiteHeader />
      <main className="washi flex-1 flex items-center justify-center px-6 py-20">
        <Reveal as="div" className="w-full max-w-md text-center">
          <span className="inline-flex items-center gap-2 rounded-full pill-pearl px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em]">
            <span className="sparkle-dot" aria-hidden />
            {t('notFound.eyebrow')}
          </span>
          <div className="num text-7xl lg:text-8xl font-semibold text-cinnabar-500 mt-6">404</div>
          <h1 className="display text-2xl font-semibold mt-4">{t('notFound.title')}</h1>
          <p className="mt-3 text-muted-foreground leading-relaxed">{t('notFound.body')}</p>

          <Link
            to="/"
            className="mt-7 inline-flex h-11 items-center gap-2 px-6 rounded-lg bg-foreground text-background text-sm font-semibold hover:bg-foreground/90 transition-colors"
          >
            {t('notFound.backHome')}
            <ArrowRight size={16} className="rtl-flip" />
          </Link>

          <div className="rule mt-10" />
          <div className="mt-6 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            {t('notFound.tryThese')}
          </div>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-full border border-border bg-card px-4 py-1.5 text-sm text-foreground/80 hover:text-foreground hover:border-foreground/30 transition-colors"
              >
                {t(`nav.${l.key}`)}
              </Link>
            ))}
          </div>
        </Reveal>
      </main>
      <SiteFooter />
    </div>
  );
}
